export default __webpack_public_path__ + "media/Beverage-Water.b97518da.png";